import model from 'api'
import * as types from 'mutation-types'
import { getSessionStorage, setSessionStorage } from 'utils/storage'

const state = {
  snList: [],
  snTotal: 0,
  snParams: getSessionStorage('log_sn_condition') || {
    pageNo: 1,
    pageSize: 15,
    username: ''
  },

  loading: false
}

const getters = {}

const mutations = {
  [types.LOG_SET_SN_LIST] (state, { list, total }) {
    state.snList = list
    state.snTotal = total
  },
  [types.LOG_SET_SN_PARAMS] (state, params) {
    state.snParams = Object.assign(state.snParams, params)
  },
  [types.LOG_SET_LOADING] (state, loading) {
    state.loading = loading
  }
}

const actions = {
  async getSNList ({ commit, state }) {
    try {
      commit(types.LOG_SET_LOADING, true)
      const { list, total } = await model.Log.getSNList(state.snParams)
      commit(types.LOG_SET_SN_LIST, { list, total })
    } catch (e) {
      commit(types.LOG_SET_SN_LIST, { list: [], total: 0 })
    } finally {
      setSessionStorage('log_sn_condition', state.snParams)
      commit(types.LOG_SET_LOADING, false)
    }
  },
  async setSNParams ({ commit, dispatch }, params) {
    commit(types.LOG_SET_SN_PARAMS, params)
    await dispatch('getSNList')
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
